<template>
  <div>
    <button @click="generatePDF">Export All Invoices to PDF (Landscape)</button>
    <div id="contentToPrint">
      <div v-for="invoice in invoicesData" :key="invoice.id" class="box-print">
        <table class="invoice-table">
          <tr>
            <td :colspan="3">
              <p style="font-size: 14px">
                آدرس فرستنده: تهران -میدان جمهوری- خ جمهوری- خ گلشن (طاهربهزاد)
                -خ چنگیزی- نبش کوچه بوذر جمهری - پلاک ۲ (درب سبز رنگ) - واحد ۱
              </p>
              <p style="font-size: 14px">تلفن فرستنده: 02166120447</p>
              <p style="font-size: 14px">کد پستی فرستنده:۱۳۱۸۶۳۴۶۵۳</p>
            </td>
          </tr>
          <tr>
            <td :colspan="2">تلفن: {{ invoice.shopCustomerMobile }}</td>
            <td :rowspan="7" style="text-align: center">
              <img
                style="width: 100px"
                src="../../../../assets/images/site-logo.png"
                alt="Logo"
              />
              <br />
              فروشگاه اینترنتی کتاب باز
              <br />
              https://ketabbaaz.com
            </td>
          </tr>
          <tr>
            <td :colspan="2">
              تاریخ سفارش: {{ invoice.date }} - {{ invoice.time }}
            </td>
          </tr>
          <tr>
            <td :colspan="2">آدرس گیرنده: {{ invoice.addressForReceipt }}</td>
          </tr>
          <tr>
            <td :colspan="2">نام خریدار: {{ invoice.shopCustomerName }}</td>
          </tr>
          <tr>
            <td :colspan="2">کد پستی: {{ invoice.shopCustomerPostalCode }}</td>
          </tr>
          <tr>
            <td>روش پرداخت و خرید: {{ invoice.type }}</td>
            <td>مبلغ کل فاکتور: {{ invoice.totalPayablePrice }}</td>
          </tr>
          <tr>
            <td>کد سفارش: {{ invoice.code }}</td>
            <td>تاریخ چاپ رسید {{ currentDate }}</td>
          </tr>
          <tr>
            <td :colspan="3">
              لیست محصولات خریداری شده:
              <ul>
                <li v-for="(item, index) in invoice.details" :key="item.index">
                  ({{ index + 1 }}) {{ item.name }}: {{ item.amount }} عدد /
                  {{ Number(item.price * item.amount).toLocaleString() }} ریال
                </li>
              </ul>
            </td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import Axios from "axios";
import moment from "moment-jalaali";
import html2pdf from "html2pdf.js";

export default {
  name: "MultiPreviewShop",
  data() {
    return {
      invoicesData: [],
      currentDate: moment(new Date()).format("jYYYY-jMM-jDD HH:mm"),
    };
  },
  methods: {
    getInfo(ids) {
      const requests = ids.map((id) =>
        Axios.post(
          this.baseUrl + "/satrapp/shop/sales/getInfo/",
          { shopInvoiceId: id },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("token"),
            },
          }
        )
          .then((res) => {
            if (res.status == 200) {
              return res.data;
            } else {
              return null;
            }
          })
          .catch((err) => {
            return null;
          })
      );

      Promise.all(requests).then((results) => {
        this.invoicesData = results.filter((data) => data !== null);
      });
    },
    generatePDF() {
      const element = document.getElementById("contentToPrint");

      const options = {
        margin: 0,
        filename: "invoices-landscape.pdf",
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: { scale: 2 },
        jsPDF: { unit: "in", format: "letter", orientation: "landscape" }, // Set orientation to landscape
      };

      html2pdf().set(options).from(element).save();
    },
  },
  mounted() {
    const ids = this.$route.params.ids.split(",");
    this.getInfo(ids);
  },
};
</script>

<style lang="scss">
.box-print {
  background-color: #fff;
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  page-break-after: always;
  // border: 2px solid #000;

  .invoice-table {
    width: 100%;
    border-collapse: collapse;
    border: 1px solid #000 !important;
    tr {
      td {
        font-size: 14px;
        line-height: 1.5;
        padding: 10px;
        border: 1px solid #000;
      }
    }
  }

  ul {
    list-style: none;
    padding: 0;
    margin: 0;
  }

  @media print {
    @page {
      size: landscape;
      margin: 0;
    }

    body {
      margin: 0;
      padding: 0;
      width: 100vw;
      height: 100vh;
      overflow: visible;
    }

    .box-print {
      border: 2px solid #000;
      height: 100vh;
      width: 100vw;
      box-sizing: border-box;
    }

    .noPrint {
      display: none !important;
    }

    table,
    th,
    td {
      border: 1px solid #000;
      border-collapse: collapse;
    }
  }
}
</style>
